export const claimData = {
    success: true,
    data: {
        claim_id: "TEST1234", // [MASTER.FILENO]
        status_display: "Review Open | Pre Suit", // ?
        claim_time: "30:05:35", // TOTAL TIME SPENT ON CLAIM - verify field
        debtor_summary: "5-1", // ?

        // DONE
        client: {
            forw_no: "5848",  // [MASTER.FORW_NO]
            name: "Client Forwarding Company" // [MASFORW.NAME]
        },

        // DONE
        co_counsel: {
            coco_no: "1316", // [MASTER.COCO_NO]
            name: "Co-Counsel Law Firm" // [MASCOCO.NAME]
        },

        // DONE
        creditor: {
            client_no: "123", // [MASTER.CLIENT_NO]
            name: "Original Creditor Name" // [MASTER.CLIENT_NAME]
        },

        file_info: {
            forw_fileno: "1096442", // [MASTER.FORW_FILENO]
            coco_fileno: "coco 101" // [MASTER.COCO_FILENO]
        },

        assigned_staff: {
            attorney: 3, // [MASTER.ATTY]
            collector: 90, // [MASTER.COLLECTOR]
            paralegal: 1, // [MASTER.PARA]
            salesperson: 0 // [MASTER.SALES_NO]
        },

        status_info: {
            stat1_code: 419, // [MASTER.STAT1_CODE]
            stat1_date: "12/15/205", // [MASTER.STAT1_DATE]
            ll_code8: "XDWP", // [MASTER.LL_CODE8]
            ll_date: "12/15/205" // [MASTER.LL_DATE]
        },

        custom_fields: {
            status1: "High Priority Review",
            priority: "Urgent",
            oer_diem: "Standard Rate"
        }
    },
    metadata: {
        retrieved_at: "2024-01-30T10:00:00Z",
        debtor_count: 2
    }
};

export const searchResults = {
    success: true,
    data: {
        results: [
            {
                claim_id: "TEST1234",
                forw_fileno: "1096442",
                client_no: "5848",
                client_name: "Client Forwarding Company",
                status: "Review Open | Pre Suit",
                total_due: 58.92,
                debtor_count: 2,
                status_code: 419
            },
            {
                claim_id: "TEST5678",
                forw_fileno: "1096443",
                client_no: "5849",
                client_name: "Another Forwarding Co",
                status: "Active | In Suit",
                total_due: 1250.50,
                debtor_count: 1,
                status_code: 420
            }
        ],
        pagination: {
            total: 2,
            page: 1,
            per_page: 20,
            total_pages: 1
        }
    }
};